import { configureStore } from "@reduxjs/toolkit";
import { load, save } from "redux-localstorage-simple";

import editsReducer from "./edits";
export { editContent, resetEdit, resetAllEdits, initEditState } from "./edits";

import authReducer from "./auth";
export { setAuthToken, setShowLoginModal } from "./auth";

type StoreOptions = {
    enablePersistence: boolean;
};

const persistenceConfig = {
    states: ["edits", "auth"],
    namespace: "translator",
    disableWarnings: process.env.NODE_ENV === "test",
};

export function makeStore({ enablePersistence }: StoreOptions) {
    return configureStore({
        reducer: {
            edits: editsReducer,
            auth: authReducer,
        },
        middleware: (getDefaultMiddleware) => {
            const base = getDefaultMiddleware();
            return enablePersistence ? base.concat(save(persistenceConfig)) : base;
        },
        preloadedState: enablePersistence ? load(persistenceConfig) : undefined,
    });
}

export const store = makeStore({ enablePersistence: true });

export type IStore = typeof store;
export type IState = ReturnType<IStore["getState"]>;
export type IDispatch = IStore["dispatch"];

export {
    anyUnsavedChangesSelector,
    defaultContentItemSelector,
    docsItemSelector,
    textsItemSelector,
    unsavedChangesSelector,
} from "./selectors";
